






















import { Component, Provide, Vue } from "vue-property-decorator";
import { IStoreService } from "@/services/IStoreService";
import { container } from "@/services/registerServiceProvider";
import HeaderCmpt from "@/components/HeaderCmpt.vue";
import FooterCmpt from "@/components/FooterCmpt.vue";
import { IAgentService } from "@/services/IAgentService";
import AppUpdateCmpt from "@/components/AppUpdateCmpt.vue";
import { IAuthService } from "frontend-core";
import { ITabletAuthService } from "@/services/ITabletAuthService";

@Component({
  components: {
    AppUpdateCmpt,
    FooterCmpt,
    HeaderCmpt,
    Loader: () => import("@/components/Loader.vue"),
  },
})
export default class App extends Vue {
  @Provide()
  public readonly storeService: IStoreService = container.resolve(
    "IStoreService",
  );
  authService: IAuthService = container.resolve<IAuthService>(
    "IAuthService",
  );

  async created() {
    document.addEventListener("logout", () => {
      this.storeService.currentAgent = null;

      if (this.$route.name !== "login") {
        this.$router.push({ name: "login" });
      }
    });

    if (typeof this.$route.query.lkAuthFromTablet === "string") {
      try {
        await container.resolve<ITabletAuthService>("ITabletAuthService").loginFromTablet(this.$route.query.lkAuthFromTablet);
        await this.$router.replace({ query: {} });
      } catch (error) {
        this.authService.logout();
      }
    }

    if (this.authService.isAuth) {
      this.storeService.currentAgent = await container
        .resolve<IAgentService>("IAgentService")
        .getCurrent();

      if (!this.storeService.currentAgent) {
        this.authService.logout();
      }
    }

    this.storeService.appState.transition("idle");
  }
}
